/** Parse SSE across arbitrary network chunks, including CRLF, comments and multiline data. */
export async function readEventStream(
  body: ReadableStream<Uint8Array>,
  signal: AbortSignal,
  onData: (data: string, id: string | null) => void,
) {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let data: string[] = [];
  let id: string | null = null;
  const cancel = () => {
    void reader.cancel().catch(() => undefined);
  };
  signal.addEventListener('abort', cancel, { once: true });
  const line = (value: string) => {
    if (!value) {
      if (data.length) onData(data.join('\n'), id);
      data = [];
      id = null;
    } else if (value.startsWith('data:')) data.push(value.slice(5).replace(/^ /, ''));
    else if (value.startsWith('id:')) id = value.slice(3).trim();
  };
  try {
    while (!signal.aborted) {
      const part = await reader.read();
      if (part.done || signal.aborted) break;
      buffer += decoder.decode(part.value, { stream: true });
      if (buffer.length > 1_000_000) throw new Error('Mio returned an oversized event.');
      let newline = buffer.indexOf('\n');
      while (newline !== -1) {
        line(buffer.slice(0, newline).replace(/\r$/, ''));
        buffer = buffer.slice(newline + 1);
        newline = buffer.indexOf('\n');
      }
    }
  } finally {
    signal.removeEventListener('abort', cancel);
    reader.releaseLock();
  }
}
